import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=4dd8ac8c&scoped=true&"
import script from "./Page7.vue?vue&type=script&lang=js&"
export * from "./Page7.vue?vue&type=script&lang=js&"
import style0 from "./Page7.vue?vue&type=style&index=0&id=4dd8ac8c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8ac8c",
  null
  
)

export default component.exports